var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Search from '@assets/svg/search-normal.svg';
import './InputSearch.scss';
var InputSearch = function (_a) {
    var setSearch = _a.setSearch;
    return (_jsxs("div", __assign({ className: "InputSearch" }, { children: [_jsx("input", { onChange: function (e) { return setSearch && setSearch(e.target.value); }, className: "Input", placeholder: "\u041F\u043E\u0438\u0441\u043A" }), _jsx(Search, { className: "Search" })] })));
};
export default InputSearch;
